/**
 * Edición del producto con la que se buildeó esta PWA.
 *
 * - "offline": habla con el server local de la sucursal (opera 24/7 sin internet).
 * - "online": habla con el cloud compartido (`https://<cloud>/pos`); requiere
 *   identificar la empresa por RUC antes del login.
 *
 * Se fija en build time con `VITE_EDITION`.
 */

export type Edition = "offline" | "online";

export const EDITION: Edition =
  (import.meta.env.VITE_EDITION as string | undefined) === "online" ? "online" : "offline";

export const IS_ONLINE_EDITION = EDITION === "online";
